import axios from "~/plugins/axios";

export default {
  get() {
    return axios.get("/web_api/v1/mailbox").then((response) => response.data);
  },
  getByUser(userId) {
    return axios.get(`/web_api/v1/mailbox/by_user/${userId}`).then((response) => response.data);
  },
  getWithoutEmailAccountByUser(userId) {
    return axios.get(`/web_api/v1/mailbox/by_user/${userId}/without_email_account`).then((response) => response.data);
  },
};
